var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-forum-layout',{staticClass:"new-post",attrs:{"searchbar":false}},[_c('r-forum-table',[_c('template',{slot:"title"},[_vm._v(" New topic ")]),_c('template',{slot:"contents"},[_c('r-post-form',{attrs:{"forum":_vm.$route.params.id}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }